module.exports = __webpack_public_path__ + "img/package_small.ff80d88b.png";